import styled from '@emotion/styled'
import { theme as newTheme } from 'styles/theme/hav-theme'

export const TamanhosStyled = styled('div')`
  .column {
    display: flex;
    flex-direction: column;
    margin-bottom: ${newTheme.spacing.xm};
    flex-grow: 0;
    margin-right: ${newTheme.spacing.xm};
  }
  @media (min-width: ${newTheme.breakpoints.xl}px) {
    :nth-of-type(14n).column {
      margin-right: 0;
    }
  }
`

export const MixedBoxValue = styled.div`
  position: absolute;
  top: 4px;
  right: 8px;

  width: fit-content;
  opacity: ${newTheme.effects.opacity.md};
`
